import { isValidElement as o } from "react";
import { ThemeIconSizeVariable as e } from "../../theme/theme-types.js";
const m = {
  md: e.Small,
  sm: e.XSmall
}, t = (r) => typeof r == "string" ? !0 : o(r) ? t(r.props.children) : Array.isArray(r) ? r.every((n) => t(n)) : !1;
export {
  m as IconSizeConstants,
  t as checkChildRendersToString
};
